import { formatText, TextRole } from '@pickleballinc/lib/format-text';

import { FriendModalType, RatingSlideType } from '@/modules/players/v3/types/friend';

export const FRIENDS_QUERY_KEY = 'friends';
export const RECEIVED_REQUESTS_QUERY_KEY = 'received-requests';
export const SENT_REQUESTS_QUERY_KEY = 'sent-requests';
export const BLOCKED_USERS_QUERY_KEY = 'blocked-users';
export const SUGGESTED_FRIENDS_QUERY_KEY = 'suggested-friends';
export const FRIENDS_TAB_COUNTS_QUERY_KEY = 'friends-tab-counts';
export const MUTUAL_FRIENDS_QUERY_KEY = 'mutual-friends';

export const MUTUAL_FRIENDS_PAGE_SIZE = 25;
export const DISTANCE_LABEL_CAP_MILES = 100;

export const PLAYERS_SEARCH_HREF = '/players';

export const FIND_FRIENDS_LABEL = formatText({
  text: 'Find new friends',
  role: TextRole.ButtonLabel,
});
export const FIND_PLAYERS_TO_FOLLOW_LABEL = formatText({
  text: 'Find players to follow',
  role: TextRole.ButtonLabel,
});

// Fitting as many columns as the row allows keeps every card wide enough to read a name and rating,
// rather than a fixed column count squeezing them into ellipses on mid-size screens.
export const FRIENDS_FOLLOWING_GRID =
  'grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(320px,1fr))] gap-4';

export const FRIENDS_SORT_ALPHABETICAL = 'alphabetical';
export const FRIENDS_SORT_OLDEST_FIRST = 'oldest_first';
export const FRIENDS_SORT_NEWEST_FIRST = 'newest_first';

export const SORT_OPTIONS = [
  { label: 'Alphabetical', value: FRIENDS_SORT_ALPHABETICAL },
  { label: 'Oldest First', value: FRIENDS_SORT_OLDEST_FIRST },
  { label: 'Newest First', value: FRIENDS_SORT_NEWEST_FIRST },
];

export const FRIEND_TABS = [
  { label: 'All friends', href: '', showTabCount: true },
  { label: 'Received', href: '/received', showTabCount: true },
  { label: 'Sent', href: '/sent', showTabCount: true },
  { label: 'Suggestions', href: '/suggestions', showTabCount: false },
  { label: 'Blocked', href: '/blocked', showTabCount: true },
];

export const DEFAULT_FRIEND_MODAL_TITLES: Record<FriendModalType, string> = {
  [FriendModalType.PLAYER_INFO]: 'About',
  [FriendModalType.FRIEND]: 'Friend',
  [FriendModalType.ACCEPT_FRIEND_REQUEST]: 'Accept Friend Request',
  [FriendModalType.REJECT_FRIEND_REQUEST]: 'Reject Friend Request',
  [FriendModalType.REVOKE_FRIEND_REQUEST]: 'Revoke Friend Request',
  [FriendModalType.SEND_FRIEND_REQUEST]: 'Send Friend Request',
};

export const DEFAULT_FRIEND_MODAL_PRIMARY_ACTION_LABELS: Partial<Record<FriendModalType, string>> =
  {
    [FriendModalType.FRIEND]: 'Block account',
    [FriendModalType.ACCEPT_FRIEND_REQUEST]: 'Accept',
    [FriendModalType.REJECT_FRIEND_REQUEST]: 'Reject',
  };

export const FRIENDS_ITEMS_PER_PAGE = 16;

export const RATING_SLIDES = Object.values(RatingSlideType);
